import {
  formatFranchiseAwareName,
  renderFranchiseAwareNameColumn,
} from '../../../helpers/franchiseNameFormatter';

// Thin wrappers preserving the existing public API. The actual logic lives
// in src/helpers/franchiseNameFormatter.tsx and is shared with the events
// grid's name column.

export const formatCampaignName = (campaign, isSystemAdmin) =>
  formatFranchiseAwareName(campaign, isSystemAdmin);

export const renderCampaignNameColumn = (isSystemAdmin) =>
  renderFranchiseAwareNameColumn(isSystemAdmin);
